module.exports = {
  BUILD_VERSION: '0.1.0',
  COPYRIGHT: '2020 Siemens Energy',
};
